var render = function render(){
  var _vm$presets;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "width": "300",
      "value": true
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('close', _vm.staged);
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "ma-3",
    staticStyle: {
      "right": "0"
    },
    attrs: {
      "absolute": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close', _vm.staged);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Select color")]), (_vm$presets = _vm.presets) !== null && _vm$presets !== void 0 && _vm$presets.length ? [_c('v-divider'), _c('div', {
    staticStyle: {
      "padding": "6px"
    }
  }, _vm._l(_vm.presets, function (c) {
    return _c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      key: c,
      staticClass: "ma-2",
      style: {
        'background': c,
        'border': _vm.staged == c ? '1px solid rgba(0, 0, 0, 0.12)' : null,
        'box-shadow': _vm.staged == c ? `0 0 8px 4px ${c} !important` : null
      },
      attrs: {
        "fab": "",
        "x-small": ""
      },
      on: {
        "click": function ($event) {
          _vm.staged = c;
          _vm.$emit('input', c);
        }
      }
    });
  }), 1)] : _vm._e(), _c('v-divider'), _c('v-color-picker', {
    attrs: {
      "mode": "rgba"
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', _vm.staged);
      }
    },
    model: {
      value: _vm.staged,
      callback: function ($$v) {
        _vm.staged = $$v;
      },
      expression: "staged"
    }
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }